export function initializeEngagementSliders(){
  $(".engagement-select2.max-select").select2({
    placeholder: "Max",
    tags: true,
    dropdownCssClass: "engagement-select-dropdown",
    width: '150px',
    allowClear: true
  });

  $(".engagement-select2.min-select").select2({
    placeholder: "Min",
    tags: true,
    dropdownCssClass: "engagement-select-dropdown",
    width: '150px',
    allowClear: true
  });

  $(document).on('keydown', '.engagement-select-dropdown .select2-search__field', function () {
    // Removed because: a) it was preventing the user from typing in the input field using the number pad, and b) it is now deprecated and should be handled another way
    // console.log(event.which)
    // if ((event.which < 48 || event.which > 57) && event.which != 8 && event.which != 189) {
    //   event.preventDefault();
    // }
  });

  $(document).on('click', '.engagement-select-dropdown .select2-search__field', function (event) {
    event.stopPropagation();
  });
}


export function generateParamsForActorSetAttributes(event, params){
  var filter_name = event.target.getAttribute("data-attribute-name")
  var filter_data_type = event.target.getAttribute("data-filter-data-type")
  var containerClass = `${filter_name}-dropdown-filter`
  var filter_type = event.target.getAttribute("data-attribute-type")

  if(filter_data_type == "single_select" || filter_data_type == "multi_select"){
    params.delete(`${filter_type}[${filter_name.split('-')[1]}]`)
    var checked = $(`.${containerClass}:checkbox:checked`)
    let values = []

    checked.each(function(i, element) {
      values.push(element.value)
    });

    if (values.length != 0) {
      params.append(`${filter_type}[${filter_name.split('-')[1]}]`, values)
    }
  } else if(filter_data_type == "boolean") {
    params.delete(`${filter_type}[${filter_name.split('-')[1]}]`)
    var checked = $(`.${filter_name}`).find("input[type='radio']:checked")
    if(checked) params.append(`${filter_type}[${filter_name.split('-')[1]}]`, checked.val())
  } else if(filter_data_type == "date" || filter_data_type == "number") {
    params.delete(`${filter_type}[${filter_name.split('-')[1]}][from]`)
    params.delete(`${filter_type}[${filter_name.split('-')[1]}][to]`)

    var from_date = $(`.${filter_name}`).find("input.from-field").val()
    var to_date = $(`.${filter_name}`).find("input.to-field").val()

    params.append(`${filter_type}[${filter_name.split('-')[1]}][from]`, from_date)
    params.append(`${filter_type}[${filter_name.split('-')[1]}][to]`, to_date)
  }
  
  return params
}

export function updateDropdownMenuPositionInExtendedFilters(){
  $("#collapseFilters .dropdown-menu").each(function(i, elem){
    let dropdown_toggle_btn = $(elem).prev()
    let percentage = (dropdown_toggle_btn.offset().left/$(window).width())*100;
    if(percentage > 75){
      $(elem).addClass("dropdown-menu-right");
    } else {
      $(elem).removeClass("dropdown-menu-right");
    }
  })
}

export function getAppliedParams(event, filter_container, param_name){
  let params = {}
  
  if(param_name.includes("actor_set_attributes")){
    let applied_params = generateParamsForActorSetAttributes(event, new URLSearchParams());
    let sanitized_params = new URLSearchParams(applied_params.toString());

    sanitized_params.forEach((value, key) => {
      if(value) params[key] = value;
    });

  } else {
    params[`${param_name}`] = []

    if(param_name == "keyword"){
      let text = filter_container.find("input[type='text']").val()
      if(text.length > 0){
        params[`${param_name}`] = text;
        filter_container.find("input[type='checkbox']:checked").each(function(i, elem){
          params[`${elem.name}`] = $(elem).val() 
        });
      }

    } else if(param_name == "post_details") {
      filter_container.find("input[type='checkbox']:checked").each(function(i, elem){
        let key_name = $(elem).parents(".parameter-name").data("name") + "[]"
        if(key_name in params) { 
          params[key_name].push(elem.value)
        } else {
          params[key_name] = [elem.value]
        }
      });

    } else if(param_name == "published_at_from") {
      let param_value = filter_container.find("input[type='radio']:checked").val()

      if(param_value == "customDates"){
        params['published_at_from'] = filter_container.find("input.from-date").val()
        params['published_at_to'] = filter_container.find("input.to-date").val()
      } else {
        params[`${param_name}`] = param_value
        params["label"] = param_value
      }
      
    } else if(param_name == "engagement"){
      filter_container.find(".engagement-select2").each(function(i, elem){
        if($(this).val()){
          params[`${$(this).data("param-name")}`] = $(this).val();
        }
      })
    }
    else if(param_name == "project_labels[]" || param_name == "language_code[]" || param_name == "channel_ids[]" || param_name == "actor_ids[]") {
      filter_container.find("input[type='checkbox']:checked").each(function(i, elem){
        params[`${param_name}`].push(elem.id.split("-")[1])
      });
    }
    else {
      filter_container.find("input[type='checkbox']:checked").each(function(i, elem){
        params[`${param_name}`].push(elem.id)
      });
    }
  }

  params = removeEmptyKeys(params)

  return params
}

function removeEmptyKeys(obj) {
  for (const key in obj) {
    if (!obj[key] || obj[key].length == 0) {
      delete obj[key];
    }
  }
  return obj;
}



